import { DrinkingDays } from "../types";
import { UpdateDrinkForDay } from "../actions";

export const updateDrinkQuantityReducer = (
  state: DrinkingDays,
  payload: UpdateDrinkForDay
): DrinkingDays => {
  return {
    ...state,
    [payload.day]: {
      ...state[payload.day],
      [payload.drink]: payload.amount
    }
  };
};
